import { Children, cloneElement, Component } from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import { themr } from '../react-css-themr'
import { LIST } from '../identifiers'
import InjectListItem from './ListItem'

const mergeProp = (propName, child, parent) =>
  child[propName] !== undefined ? child[propName] : parent[propName]

const factory = ListItem => {
  class List extends Component {
    static propTypes = {
      children: PropTypes.node,
      className: PropTypes.string,
      theme: PropTypes.shape({
        list: PropTypes.string,
      }),
      ripple: PropTypes.bool,
      selectable: PropTypes.bool,
    }

    renderItems() {
      const { children, ripple = false, selectable = false } = this.props

      return Children.map(children, item => {
        if (item === null || item === undefined) {
          return item
        } else if (item.type === ListItem) {
          const itemSelectable = mergeProp('selectable', item.props, { selectable })
          const itemRipple = mergeProp('ripple', item.props, { ripple })
          return cloneElement(item, { selectable: itemSelectable, ripple: itemRipple })
        }
        return cloneElement(item)
      })
    }

    render() {
      const { className = '', theme } = this.props
      return (
        <ul data-react-toolbox='list' className={cx(theme.list, className)}>
          {this.renderItems()}
        </ul>
      )
    }
  }

  return List
}

const List = factory(InjectListItem)
export default themr(LIST)(List)
export { factory as listFactory }
export { List }
